import gql from 'graphql-tag'
export default gql`
mutation createUserServiceMapping(
  $serviceId: String!
  $siteId: String!
  $userId: String!
  $type: String!
  $boardingAmount: Float!
  $renewalAmount: Float!
  $siteOptions: SITE_OPTIONS
  $note: String
  $serviceName: String!
){
createUserServiceMapping(input: {
  serviceId: $serviceId
  siteId: $siteId
  userId: $userId
  type: $type
  boardingAmount: $boardingAmount
  renewalAmount: $renewalAmount
  siteOptions: $siteOptions
  note: $note
  serviceName: $serviceName
})
}
`

    